module.exports = __webpack_public_path__ + "img/login_bg0.203dd8f2.jpg";